import { Component } from '@angular/core';

@Component({
  selector: 'app-dtr-manager',
  templateUrl: './dtr-manager.component.html',
  styleUrls: ['./dtr-manager.component.scss']
})
export class DtrManagerComponent {

}
